<div class="mdv">
  <app-loader></app-loader>
  <router-outlet></router-outlet>
</div>
